import { useEffect, useRef, useState } from "react";
import * as XLSX from "xlsx";
import Navbar from "../components/Navbar";
import { CalendarInput } from "../components/FormComps";
import Pagination , { PagiSearch } from "../components/Pagination";
import { dateInNumbers, postApiSetting, shortDate } from "../assets/functions";
import { ToastContainer, toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
import { TableStatusRow, StatusBadge, ButtonSpinner } from "../components/UI";
export default function PTPReport ({setAuth}) {
 const navigate = useNavigate();
    const fromDateRef = useRef(null);
    const toDateRef = useRef(null);

    const [transactinoData, setTransactinoData] = useState([]);
    const [startOffset, setStartOffset] = useState(0);
    const [search, setSearch] = useState('');
    const [tableDataStatus, setTableDataStatus] = useState('');
    const [downloading, setDownloading] = useState(false);
    const searchLoading = tableDataStatus === 'Loading...';

    const itemsPerPage = 10;
    const searchData = transactinoData.filter(item => Object.values(item).join("").toString().toLowerCase().includes(search.toLowerCase()))
    const endOffset = startOffset + itemsPerPage;
    const currentItems = searchData.slice(startOffset, endOffset)
    const pageCount = Math.ceil(searchData.length / itemsPerPage)

    useEffect(()=>{
        CommonPTPReport();
    },[])

    const CommonPTPReport = async () => {
        let currentDate = shortDate(new Date().toISOString().split('T')[0])
        let fDate = fromDateRef.current.value || currentDate;
        let tDate =  toDateRef.current.value || currentDate;
        // if(!fDate || !tDate) {
        //     alert('Report date are required.')
        //     return false;
        // }
        setTableDataStatus('Loading...')
        setTransactinoData([])
        let postSetting = postApiSetting({fDate,tDate})
        let res = await fetch('/Admin/api/Admin/ptpReportData', postSetting);
        // let res = await fetch('/api/Admin/ptpReportData', postSetting);
        let result = (res.status === 200) ? await res.json(): "";
        // console.log(res)
        // console.log(result)
        if(res.status === 200){
            if(result.data.length < 1){
                setTableDataStatus('Not Found');
            }else{
                let data = result.data.sort(function(a, b) {
                    let c = new Date(a.requestInitiatedDateTime);
                    let d = new Date(b.requestInitiatedDateTime);
                    return d-c;
                })
                setTableDataStatus('');
                setTransactinoData(data)
            }
        } else if(res.status === 401)
                { 
                    setAuth(false)
                    toast.error("Session Expired !", {position: 'top-center',});
                    navigate("/");                  
                    sessionStorage.clear();
                }
    }

    const downloadReport = () => {
        setDownloading(true)
        setTimeout(() => {
            let data = searchData.map((item) => {
                return {...item,
                    payAmount:(item.payAmount/100).toString(),
                    requestAmount:(item.requestAmount/100).toString()
                }
            })
            let date = dateInNumbers();
            let workbook = XLSX.utils.book_new();
            let worksheet = XLSX.utils.json_to_sheet(data);
            XLSX.utils.book_append_sheet(workbook, worksheet, "TxnReport");
            XLSX.writeFile(workbook, `TxnReport_${date}.xlsx`);
            setDownloading(false)
        }, 0)
    }

    return (<>
        {/* <SidebarNavigation /> */}
        <ToastContainer />
        <section className="transaction-page">
            <Navbar title="PTP REPORT" />
            <div className="container-fluid pe-3">
                <div className="main-content my-3">
                    <h6 className="mb-3">PTP Report</h6>
                    <form className="mb-4">
                        <div className="row align-items-end">
                            <div className="col-sm-2">
                                <CalendarInput label="From Date" showDate={true} dateRef={fromDateRef} />
                            </div>
                            <div className="col-sm-2">
                                <CalendarInput label="To Date" showDate={true} dateRef={toDateRef} />
                            </div>
                            <div className="col-sm-3">
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={CommonPTPReport} disabled={searchLoading}>
                                {searchLoading ? <ButtonSpinner /> : <i className="fa-solid fa-magnifying-glass"></i>} Search</button>
                                <button type="button" className="btn btn-sm _themebg-0 text-white me-3" onClick={downloadReport} disabled={downloading}>
                                {downloading ? <ButtonSpinner /> : <i className="fa-solid fa-file-arrow-down pe-1"></i>}Download</button>
                            </div>
                        </div>
                    </form>

                    <PagiSearch setSearch={setSearch}
                    totalEntries={searchData.length}
                    setStartOffset={setStartOffset}
                    setTableDataStatus={setTableDataStatus} />

                    <div className="table-responsive my-2 com-table">
                    <table className="table table-bordered mb-1">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Amount</th>
                                <th>UTR</th>
                                <th>UTR Status</th>
                                <th>Msg Recieved Time</th>
                                <th>Order No</th>
                                <th>Transaction No</th>
                                <th>Refund UTR</th>
                                <th>Message</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentItems.length < 1 ? <TableStatusRow colSpan={9} status={tableDataStatus} /> :
                            currentItems.map((item,index) => {
                                return (
                                <tr key={index}>
                                    <td>{startOffset + index + 1}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.utr}</td>
                                    <td><StatusBadge status={item.utrStatus} /></td>
                                    <td>{item.msgRecievedTime}</td>
                                    <td>{item.orderNo}</td>
                                    <td>{item.transactionNo}</td>
                                    <td>{item.refundUtr}</td>
                                    <td>{item.message}</td>
                                </tr>
                                )
                            })}
                        </tbody>
                    </table>
                    </div>

                    <Pagination setStartOffset={setStartOffset}
                    pageCount={pageCount} itemsPerPage={itemsPerPage} />

                </div>
            </div>
        </section>
    </>)
}